import {useCompanyTariffGuard} from '../../../modules/company-tariff';
import {FC, useContext, useEffect, useState} from 'react';
import {useRecoilStateLoadable} from 'recoil';

import Fallback from '../../../ui/fallback/Fallback';
import NotFoundError from '../../../ui/not-found/NotFoundError';
import NavCards from '../../../ui/nav-cards/NavCards';
import AddIcon from '@mui/icons-material/Add';
import {Button, Stack} from '@mui/material';

import {EventBusContext} from '../../../providers/EventBus';

import {green} from '@mui/material/colors';

import styles from './ReasonRejections.module.scss';
import {reasonRejectionsDictQuery} from '../../../store/reasonRejections/selectors';
import {IReasonRejectionsDict} from '../../../shared/types/reasonRejectionsDict.types';
import {ModalNewReasonRejection} from '../../../components/Dictionaries/ReasonRejections/reason-rejection/ModalNewReasonRejection';

const ReasonRejectionsPage: FC = () => {
  const {checkTariff, tariffLoading} = useCompanyTariffGuard();
  const [{state, contents}, setReasonRejections] = useRecoilStateLoadable(reasonRejectionsDictQuery);
  const [open, setOpen] = useState(false);
  const {bus} = useContext(EventBusContext);

  const toggleModalToCreate = () => {
    if (!open && !checkTariff()) return;
    setOpen(!open);
  };

  useEffect(() => {
    state === 'hasValue' && setReasonRejections(contents);

    state === 'hasError' &&
      bus?.emit('error', [
        contents,
        {
          toastId: 'reasonRejections',
        },
      ]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return state === 'loading' ? (
    <Fallback />
  ) : state === 'hasError' ? (
    <NotFoundError />
  ) : (
    <div className={styles.deviceTypes}>
      <Stack direction="row" sx={{justifyContent: 'center', mt: 4}}>
        <Button
          onClick={toggleModalToCreate}
          disabled={tariffLoading}
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          sx={{
            height: '40px',
            fontSize: '0.87rem',
            whiteSpace: 'nowrap',
            letterSpacing: '0',
            backgroundColor: green[500],
            textTransform: 'none',
            '&:hover': {
              backgroundColor: green[600],
            },
          }}
        >
          Добавить причину отмены
        </Button>
      </Stack>
      <div className={styles.navCards}>
        <NavCards
          variant="grid"
          menu={contents.content.map((item: IReasonRejectionsDict) => ({
            link: `/dictionaries/reasonRejections/${item.code}`,
            title: item.name,
          }))}
        />
      </div>
      {open && <ModalNewReasonRejection open={open} handleClose={toggleModalToCreate} />}
    </div>
  );
};

export default ReasonRejectionsPage;
